import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TechnicalDescriptionTemplate } from 'src/app/shared/models/data/technicalDescriptionTemplates.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { CustomIcoCol } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { parseGridActionEvent } from 'src/app/shared/utils/grid-event.utils';

@Component({
  selector: 'app-modal-technical-description',
  templateUrl: './modal-technical-description.component.html',
  styleUrls: ['./modal-technical-description.component.scss']
})
export class ModalTechnicalDescriptionComponent implements OnInit {
  @Input() isMobile: boolean = false;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  @Output() onSelectedTemplate: EventEmitter<TechnicalDescriptionTemplate> = new EventEmitter();



  customIcoCols: CustomIcoCol[] = new Array();

  isLoading = false;
  technicalDescriptionTemplates: TechnicalDescriptionTemplate[] = new Array();
  title = 'quotation.technicalDescTemplates';
  gridColumnsToShow = ['templateName'];


  constructor(private backendService: BackendService, private translate: TranslateService, private loader: TeiasoftLoaderService) {

  }

  ngOnInit(): void {
    this.loadTemplates();
    this.buildCustomIconGrid();
  }

  buildCustomIconGrid() {
    this.customIcoCols = new Array();

    let _item: CustomIcoCol = new CustomIcoCol();
    _item.action = "select-template";
    _item.icon = 'fa-light fa-arrow-up-right-from-square';
    _item.label = this.translate.instant("quotation.confirmImport");
    this.customIcoCols.push(_item);

  }

  loadTemplates() {
    this.loader.start();
    this.backendService.getTechnicalDescriptionTemplates().subscribe({
      next: (data) => {
        this.technicalDescriptionTemplates = data.technicalDescriptionTemplates || [];
      },
      complete: () => {
        this.loader.stop();
      }
    });
  }

  onCloseClick() {
    this.closeModal.emit(true);
  }

  customIconClick($event: any) {
    const { action, row } = parseGridActionEvent<TechnicalDescriptionTemplate>($event);
    if (action === 'select-template' && row) {
      this.onSelectedTemplate.emit(row);
      this.onCloseClick(); // should i close the modal or leave it open so the caller can choose ?
    }
  }

  onRowDeleteClick($event: any) {
    if (!$event.id)
      return;

    this.loader.start();
    this.backendService.deleteTechnicalDescriptionTemplate($event.id).subscribe({
      complete: () => {
        this.loadTemplates();
        this.loader.stop();
      }
    });
  }

  

}
